// Navbar.jsx

import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../../styles.css";
import "react-awesome-button/dist/styles.css";
import logo2 from "../../Assets/MainAssets/logo_brown-03.png"; // Update the path if necessary

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleScroll = (e, sectionId) => {
    e.preventDefault();
    const section = document.getElementById(sectionId);
    if (section) {
      const top =
        section.getBoundingClientRect().top + window.pageYOffset - 100; // Offset -100 pixels
      window.scrollTo({ top, behavior: "smooth" });
    }
    // Close the menu after clicking on a link
    setIsMenuOpen(false);
  };

  return (
    <nav className="navbar">
      <a href="/" className="navbar-logo">
        <img src={logo2} alt="Digitomy Logo" />
      </a>
      <div
        className="navbar-menu-icon"
        onClick={() => setIsMenuOpen(!isMenuOpen)}
      >
        <div className={`menu-icon ${isMenuOpen ? "open" : ""}`}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
      <div className={`navbar-links ${isMenuOpen ? "active" : ""}`}>
        {location.pathname === "/" ? (
          <>
        {["About", "Demo", "Team", "Collaborators", "Patents", "Contact"].map(
          (text) => (
            <button
              key={text}
              onClick={(e) => handleScroll(e, text.toLowerCase())}
              style={{
                background: "none",
                border: "none",
                    color: "black",
                margin: "0 20px",
                textDecoration: "none",
                transition: "color 0.3s, border-bottom 0.3s",
                position: "relative",
                cursor: "pointer",
                padding: "10px 0",
                fontSize: "16px",
                fontFamily: "inherit",
              }}
            >
              {text}
            </button>
          )
            )}
            <button
              onClick={() => {
                navigate("/auth");
                setIsMenuOpen(false);
              }}
              className="ml-4 px-6 py-2 bg-gradient-to-r from-indigo-500 to-purple-500 text-white rounded-full font-semibold hover:from-indigo-600 hover:to-purple-600 transition-all duration-200 shadow-md hover:shadow-lg"
              style={{
                border: "none",
                cursor: "pointer",
                fontSize: "16px",
                fontFamily: "inherit",
              }}
            >
              Trap Annotate →
            </button>
          </>
        ) : (
          <button
            onClick={() => {
              navigate("/");
              setIsMenuOpen(false);
            }}
            style={{
              background: "none",
              border: "none",
              color: "black",
              margin: "0 20px",
              textDecoration: "none",
              transition: "color 0.3s",
              cursor: "pointer",
              padding: "10px 0",
              fontSize: "16px",
              fontFamily: "inherit",
            }}
          >
            ← Back to Home
          </button>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
